import React, { useEffect } from 'react';
import { AccountMenuProps } from './Header.types';
import classnames from 'classnames';

const AccountMenu = ({
  accountMenuRef,
  isSmallScreen = false,
  isSmallScreenWithAccountButton,
  handleAccountAction,
  handleProfileButtonClick,
  handleDashboardButtonClick,
  isAccountMenuShown,
  handleOutsideClick,
  menuIsInView,
}: AccountMenuProps) => {
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [isAccountMenuShown]);

  return (
    <div
      ref={accountMenuRef}
      className={classnames([
        'tfl-header__account-menu',
        `tfl-header__account-menu--${
          isSmallScreen || isSmallScreenWithAccountButton ? 'mobile' : 'desktop'
        }`,
        `tfl-header__account-menu--${menuIsInView ? 'in-view' : 'not-in-view'}`,
      ])}
      role="menu"
      aria-modal="true"
    >
      <h2>Hello</h2>
      <div className={'tfl-header__account-menu-button-container'}>
        <button
          className={'tfl-button tfl-button--icon-right-chevron'}
          onClick={handleDashboardButtonClick}
        >
          Dashboard
        </button>
        <button
          className={'tfl-button tfl-button--icon-right-chevron'}
          onClick={handleProfileButtonClick}
        >
          Profile
        </button>
      </div>
      <button
        id="account-menu-sign-out-btn"
        className="tfl-button tfl-button--primary"
        onClick={(e) => handleAccountAction(e)}
      >
        Sign out
      </button>
    </div>
  );
};

export default AccountMenu;
